import { render, staticRenderFns } from "./SPanel.vue?vue&type=template&id=331c4a03&scoped=true&"
import script from "./SPanel.vue?vue&type=script&lang=js&"
export * from "./SPanel.vue?vue&type=script&lang=js&"
import style0 from "./SPanel.vue?vue&type=style&index=0&id=331c4a03&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331c4a03",
  null
  
)

export default component.exports